import {createAction, handleActions} from 'redux-actions';
import {Map, List, fromJS/*, setIn*/} from 'immutable';
import {pender} from 'redux-pender';
import * as api from 'lib/api';

const SET_WCLFILTER_OPT = 'wow/SET_WCLFILTER_OPT';
const GET_WCL_REQUEST_INFO = 'wow/GET_WCL_REQUEST_INFO';
const SET_PENDING_INIT = 'wow/SET_PENDING_INIT';
const GET_WCL_REPORT = 'wow/GET_WCL_REPORT';
const SET_REPORT_LOADING = 'wow/SET_REPORT_LOADING';
const GET_ITEM_LIST = 'wow/GET_ITEM_LIST';
const SET_BISFILTER_OPT = 'wow/SET_BISFILTER_OPT';
const SET_WOWFIND_LANG = 'wow/SET_WOWFIND_LANG';
const SET_BISFILTER_RESET = 'wow/SET_BISFILTER_RESET';

export const setWclFilterOpt = createAction(SET_WCLFILTER_OPT);
export const getWclRequestInfo = createAction(GET_WCL_REQUEST_INFO, api.getWclInfo);
export const setPendingInit = createAction(SET_PENDING_INIT);
export const getWclRequestReport = createAction(GET_WCL_REPORT, api.getWclRequestReport);
export const setReportLoading = createAction(SET_REPORT_LOADING);
export const getItemList = createAction(GET_ITEM_LIST, api.getWowItemList);
export const setBisFilterOpt = createAction(SET_BISFILTER_OPT);
export const setWowfindLang = createAction(SET_WOWFIND_LANG);
export const setBisFilterReset = createAction(SET_BISFILTER_RESET);

const initialState = Map({
  lang : 'kr',
  wclFind: Map({
    url: 'https://ko.warcraftlogs.com/zone/rankings/42#',
    wclFilter0: {value: '', text: '', color: '', classes: ''},
    wclFilter1: {value: '&boss=3009', text: '벡시와연마공', color: 'white', classes: ''},
    wclFilter2: {value: '', text: '', color: '', classes: ''},
    wclFilter3: {value: '', text: '', color: '', classes: ''},
    wclFilter4: {'iconIndex':'0','value':'&class=DeathKnight','text':'죽음의기사','color':'#c41f3b','classes':''},
    metric:'',
    boss:'',
    difficulty:'',
    region:'',
    class1:'',
    spec:'',
    ranker: List(),
    ranker_pending: '',
    report_pending: ''
  }),
  wowBis: Map({
    itemList: List(),
    itemList_pending: '',
    bisFilter: Map({
      isFan: 'N', isSasl: 'N', isGajuk: 'N', isChun: 'N',
      isCri: 'N', isHas: 'N', isMas: 'N', isVer: 'N',
      isType0: 'N', isType1: 'N', isType2: 'N', isType3: 'N', isType4: 'N',
      isType5: 'N', isType6: 'N', isType7: 'N', isType8: 'N', isType9: 'N',
      isType10: 'N', isType11: 'N', isType12: 'N', isType13: 'N', isType14: 'N', 
      isType15: 'N',
      isStr: 'N', isAgi: 'N', isInt: 'N',
      isM: 'N', isR: 'N'
    })
    ,// bisFilter: List([
      // {id:'isFan', value:'N'}, {id:'isGajuk', value:'N'}, 
      // {id:'isChun', value:'N'}, {id:'isChun', value:'N'},
      // {id:'isCri', value:'N'}, {id:'isHas', value:'N'},
      // {id:'isHas', value:'N'}, {id:'isVer', value:'N'},

      // {id:'isType0', value:'N'}, {id:'isType1', value:'N'},
      // {id:'isType2', value:'N'}, {id:'isType3', value:'N'},
      // {id:'isType4', value:'N'}, {id:'isType5', value:'N'},
      // {id:'isType6', value:'N'}, {id:'isType7', value:'N'},
      // {id:'isType8', value:'N'}, {id:'isType9', value:'N'},
      // {id:'isType10', value:'N'}, {id:'isType11', value:'N'},
      // {id:'isType12', value:'N'}, {id:'isType13', value:'N'},
      // {id:'isType14', value:'N'}, {id:'isType15', value:'N'},
      // {id:'isType16', value:'N'},
      
      // {id:'isStr', value:'N'}, {id:'isAgi', value:'N'},
      // {id:'isInt', value:'N'},
    // ])
  })
});

export default handleActions({
  [SET_WCLFILTER_OPT]: (state, action) => {
    const {name, value, alt} = action.payload;
    console.log('payload');
    console.log(action.payload);
    // const ranker_pending = state.getIn(['wclFind', 'ranker_pending']).toJS();
    const text = alt.split(',')[0];
    const color = alt.split(',')[1];
    const classes = alt.split(',')[2];
    let metric = '';
    let boss = '';
    let difficulty = '';
    let region = '';
    let class1 = '';
    let spec = '';

    // if(val.indexOf('boss') > -1) {
    //   boss = val.substr(val.indexOf('boss') + 'boss='.length);
    // }
    // if(val.indexOf('spec') > -1) {
    //   spec = val.substr(val.indexOf('spec') + 'spec='.length);
    // }

    // const pending = boss

    return state.setIn(['wclFind', name, 'value'], value)
                .setIn(['wclFind', name, 'text'], text)
                .setIn(['wclFind', name, 'color'], color)
                .setIn(['wclFind', name, 'classes'], classes)
                .setIn(['wclFind', 'metric'], metric)
                .setIn(['wclFind', 'boss'], boss)
                .setIn(['wclFind', 'difficulty'], difficulty)
                .setIn(['wclFind', 'region'], region)
                .setIn(['wclFind', 'class1'], class1)
                .setIn(['wclFind', 'spec'], spec)
                .setIn(['wclFind', 'ranker_pending'], 'Y')
                ;
  },
  ...pender({
    type: GET_WCL_REQUEST_INFO,
    onSuccess: (state, action) => {
      const {data} = action.payload;
      return state.setIn(['wclFind', 'ranker'], fromJS(data))
                  .setIn(['wclFind', 'ranker_pending'], 'N');
    },
    onPending: (state, action) => {
      return state.setIn(['wclFind', 'ranker_pending'], 'Y');
    }
  }),
  [SET_PENDING_INIT]: (state, action) => {
    return state.setIn(['wclFind', 'ranker_pending'], '')
                .setIn(['wclFind', 'report_pending'], '');
  },
  ...pender({
    type: GET_WCL_REPORT,
    onSuccess: (state, action) => {
      const {sourceID, name} = action.payload.data;
      // console.log(sourceID, name);
      const ranker = state.getIn(['wclFind', 'ranker']).toJS();
      let updateIndex = 0;
      let updateSourceID = '';

      ranker.forEach((info, cnt) => {
        if(name === info.name) {
          updateIndex = cnt;
          updateSourceID = sourceID;

          return;
        }
      });
      
      return state.setIn(['wclFind', 'report_pending'], 'N')
                  .setIn(['wclFind', 'ranker', updateIndex, 'sourceID'], updateSourceID)
                  .setIn(['wclFind', 'ranker', updateIndex, 'sourceID_ing'], 'N');
    },
    onPending: (state, action) => {
      return state.setIn(['wclFind', 'report_pending'], 'Y');
    }
  }),
  ...pender({
    type: GET_ITEM_LIST,
    onSuccess: (state, action) => {
      const {data} = action.payload;
      return state.setIn(['wowBis', 'itemList'], fromJS(data))
                  .setIn(['wowBis', 'itemList_pending'], '');
    },
    onPending: (state, action) => {
      return state.setIn(['wowBis', 'itemList_pending'], 'Y');
    }
  }),
  [SET_REPORT_LOADING]: (state, action) => {
    return state.setIn(['wclFind', 'ranker', action.payload, 'sourceID_ing'], 'Y');
  },
  [SET_BISFILTER_OPT]: (state, action) => {
    const {id} = action.payload;
    const curOpt = state.getIn(['wowBis', 'bisFilter', id]);
    const setOpt = curOpt === 'Y' ? 'N' : 'Y';

    return state.setIn(['wowBis', 'bisFilter', id], setOpt);
  },
  [SET_WOWFIND_LANG]: (state, action) => {
    const {lang} = action.payload;
    return state.setIn(['lang'], lang);
  },
  [SET_BISFILTER_RESET]: (state, action) => {
    return state.setIn(['wowBis', 'bisFilter'], {
      isFan: 'N', isSasl: 'N', isGajuk: 'N', isChun: 'N',
      isCri: 'N', isHas: 'N', isMas: 'N', isVer: 'N',
      isType0: 'N', isType1: 'N', isType2: 'N', isType3: 'N', isType4: 'N',
      isType5: 'N', isType6: 'N', isType7: 'N', isType8: 'N', isType9: 'N',
      isType10: 'N', isType11: 'N', isType12: 'N', isType13: 'N', isType14: 'N', 
      isType15: 'N',
      isStr: 'N', isAgi: 'N', isInt: 'N',
      isM: 'N', isR: 'N'
    });
  }

}, initialState);